module.exports = __webpack_public_path__ + "img/teacher-sample-m-1.5c48b503.png";